<template>
    <div class="a-switch" :class="{ 'a-switch--checked': localValue }">
        <label>
            <div class="a-switch__switch">
                <input
                    v-model="localValue"
                    type="checkbox"
                    class="a-switch__checkbox"
                    :disabled="disabled"
                />
                <span class="a-switch__slider" />
            </div>
            <template v-if="$slots.default">
                <slot />
            </template>
            <span v-else-if="text" v-text="text" />
        </label>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: false
        },
        checked: {
            type: Boolean,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localValue: {
            get() {
                return this.checked
            },
            set(val) {
                this.$emit('change', val)
            }
        }
    }
}
</script>
